import React, { useMemo } from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { PlanSetTableRow } from 'modules/components/layer23';
import { StyledTable } from 'modules/components/layer24';


export type PlanSetTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanSetTableProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  const headers = [
    'Name',
    'Number of Plans',
    'Created At',
    'Created On',
    ''
  ];



  const rows = useMemo(() => {
    return data.map((node, i) => (
      <PlanSetTableRow.FC
        key={i}
        {...node}
      />
    ));
  }, [data]);
  return (
    <StyledTable.FC
      rows={rows}
      headers={headers}
    />
  );
};
